import pLimit from 'p-limit'

export let pLimitFiveService = pLimit(5)
